let gender = document.getElementById('gender').dataset.gender

if (gender && gender != 'unset') {
  localStorage.setItem('gender', gender)
}

else {
  localStorage.getItem('gender') ? gender = localStorage.getItem('gender') : gender = 'female'
}



document.addEventListener('DOMContentLoaded', () => {
  const femaleMenuGroup = document.querySelectorAll('.conditional-female-menu')
  const maleMenuGroup = document.querySelectorAll('.conditional-male-menu')

  const maleDrawerLink = document.querySelector('[data-male-drawer-link]')
  const femaleDrawerLink = document.querySelector('[data-female-drawer-link]')

  const maleHeaderLink = document.querySelector('[data-male-header-link]')
  const femaleHeaderLink = document.querySelector('[data-female-header-link]')
  const maleElements = document.querySelectorAll('[data-male-element]')
  const femaleElements = document.querySelectorAll('[data-female-element]')


  if (gender == 'male') {
    maleDrawerLink.classList.add('menu-drawer__menu-item--active')
    maleHeaderLink.classList.add('header__active-menu-item')
    maleElements.forEach(element => {
      element.classList.remove('hidden')
    })
    femaleElements.forEach(element => {
      element.classList.add('hidden')
    })
    femaleMenuGroup.forEach(menu => {
      menu.classList.add('hidden')
    })
    maleMenuGroup.forEach(menu => {
      menu.classList.remove('hidden')
    })
  }

  else {
    femaleDrawerLink.classList.add('menu-drawer__menu-item--active')
    femaleHeaderLink.classList.add('header__active-menu-item')
    femaleMenuGroup.forEach(menu => {
      menu.classList.remove('hidden')
    })
    maleElements.forEach(element => {
      element.classList.add('hidden')
    })
    femaleElements.forEach(element => {
      element.classList.remove('hidden')
    })
  }
})

